import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import TrustBadges from './components/TrustBadges';
import CategoryGrid from './components/CategoryGrid';
import WhyVigorbuy from './components/WhyVigorbuy';
import ArticlePreview from './components/ArticlePreview';
import ArticleGrid from './components/ArticleGrid';
import Testimonial from './components/Testimonial';
import FAQ from './components/FAQ';
import NewsletterCTA from './components/NewsletterCTA';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Vigorbuy Spreadsheet',
  url: 'https://vigorbuy.casa/',
  description: 'Trusted Vigorbuy Spreadsheet directory with verified products, seller guides, and buying resources.',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://vigorbuy.casa/?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SchemaOrg data={websiteSchema} />
      <header>
        <Navbar />
        <HeroSection />
      </header>

      <main>
        <TrustBadges />
        <CategoryGrid />
        <WhyVigorbuy />
        <ArticlePreview />
        <ArticleGrid />
        <Testimonial />
        <FAQ />
        <NewsletterCTA />
      </main>

      <Footer />
    </>
  );
}